import React from 'react'

const InvestNow = () => {
    console.log("page working")
  return (
    <div>InvestNow</div>
  )
}

export default InvestNow